import type { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';

import { DASH } from '../tokens';

export interface MetricTileProps {
  value: string;
  label: string;
  detail?: ReactNode;
}

export function MetricTile({ value, label, detail }: MetricTileProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
        padding: '8px 16px',
        borderRadius: '8px',
        bgcolor: DASH.surface,
      }}
    >
      <Typography
        component="div"
        sx={{
          fontWeight: 800,
          fontSize: '32px',
          lineHeight: '40px',
          letterSpacing: '-0.0156em',
          color: DASH.ink,
        }}
      >
        {value}
      </Typography>
      <Typography
        component="div"
        sx={{ fontWeight: 500, fontSize: '16px', lineHeight: '24px', color: DASH.muted }}
      >
        {label}
      </Typography>
      {detail !== undefined && detail !== null && detail !== false && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>{detail}</Box>
      )}
    </Box>
  );
}
